import { render, staticRenderFns } from "./WidgetNutrientBalance.vue?vue&type=template&id=0a06cb52&scoped=true&"
import script from "./WidgetNutrientBalance.vue?vue&type=script&lang=js&"
export * from "./WidgetNutrientBalance.vue?vue&type=script&lang=js&"
import style0 from "./WidgetNutrientBalance.vue?vue&type=style&index=0&id=0a06cb52&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a06cb52",
  null
  
)

export default component.exports